
import Vue from "vue";

export default Vue.extend({
  created() {
    this.$snotify.config.global = {
      maxOnScreen: 5,
      preventDuplicates: true,
    };
  },

  mounted() {
    if (navigator.appVersion.indexOf("Windows NT 6.2") != -1) {
      document.head.innerHTML +=
        '<link rel="stylesheet" type="text/css" href="pages/css/windows.chrome.fix.css" />';
    }
  }
});
